import React, { useEffect } from "react";
import MyRouter from "routers/index";
// Analytics
import ReactGA from "react-ga";
ReactGA.initialize("UA-206223897-1");

function App() {
	useEffect(() => {
		ReactGA.pageview(window.location.pathname + window.location.search);
	}, []);

	return (
		<div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
			<MyRouter />
		</div>
	);
}

export default App;
